/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Optional_MarkerInputs */

const en_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const de_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const fr_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facultatif`)
};

const es_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

const it_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facoltativo`)
};

const nl_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optioneel`)
};

const pl_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcjonalne`)
};

const fi_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valinnainen`)
};

const da_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valgfrit`)
};

const sv_consent_optional_marker = /** @type {(inputs: Consent_Optional_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valfritt`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Consent_Optional_MarkerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_optional_marker = /** @type {((inputs?: Consent_Optional_MarkerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Optional_MarkerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_optional_marker(inputs)
	if (locale === "fr") return fr_consent_optional_marker(inputs)
	if (locale === "es") return es_consent_optional_marker(inputs)
	if (locale === "it") return it_consent_optional_marker(inputs)
	if (locale === "nl") return nl_consent_optional_marker(inputs)
	if (locale === "pl") return pl_consent_optional_marker(inputs)
	if (locale === "fi") return fi_consent_optional_marker(inputs)
	if (locale === "da") return da_consent_optional_marker(inputs)
	if (locale === "sv") return sv_consent_optional_marker(inputs)
	return en_consent_optional_marker(inputs)
});